import React from 'react';

import { CSVLink, CSVDownload } from "react-csv";
import { validate_m, validate_k, validate_r } from "./Uvalidation"
import 'katex/dist/katex.min.css';

import Graph from '../graph/graph'

import {
  Message,
} from 'semantic-ui-react'

const { jStat } = require('jstat');

interface IProps {
  data: any;
};

const max_count: number = 15;

const get_data = (alpha: number, beta: number) => {
  const data = []
  for (var x = 0; x < max_count; x++) {
    data.push(
      {
        name: x,
        pdf: jStat.gamma.pdf(x, alpha, beta),
      }
    )
  }
  return data
}


class UGammaDist extends React.Component<IProps, {}> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    };

  }

  render() {
    var data = get_data(this.props.data.alpha, this.props.data.beta)
    return (
      <div>
        <Graph data={data} />
        <div className='message_container'>
          <p>ガンマ分布</p>
          <CSVLink
            filename={"gamma.csv"}
            data={data}
          >
            <Message
              info
              header='Download'
              content='クリックして結果をダウンロード'
            />
          </CSVLink>
        </div>
      </div>
    );
  }
}

export default UGammaDist;
